import { render, staticRenderFns } from "./whatsAppTemplatesEdit.vue?vue&type=template&id=4d928cf0&"
import script from "./whatsAppTemplatesEdit.vue?vue&type=script&lang=ts&"
export * from "./whatsAppTemplatesEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports